import popupController from './popup.js';

popupController();

export { popupController } from './popup.js';
